
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-generals-26j-2016",
      function () {
        return require("private-next-pages/3catinfo/eleccions-generals-26j-2016/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-generals-26j-2016"])
      });
    }
  